<template>
  <div
    class="content-devx transparent headers-initial"
    style="padding: 1rem 0 !important;"
  >
    <div class="content-summary">
      <div class="table-1">
        <div
          class="head"
          style="grid-column: 1 / 4;"
        >
          Resumen (valores estacionales)
        </div>

        <div>
          Riego (mm)
        </div>
        <div>
          Volumen de riego
        </div>
        <div>{{ data.irrigation_volume }}</div>

        <div style="grid-row: 3 / 5;">
          Aportes de N en suelo (kg/ha)
        </div>
        <div>
          N mineral en el suelo
        </div>
        <div>{{ data.minerilized_N_soil }}</div>
        <div>
          N mineralizado
        </div>
        <div>{{ data.minerilized_N }}</div>

        <div
          v-if="showColumnByCrop"
          style="grid-row: 5 / 10;"
        >
          Demanda del cultivo (kg/ha)
        </div>
        <div
          v-else
        >
          Demanda del cultivo (kg/ha)
        </div>
        <div>
          Extracción de N
        </div>
        <div>{{ data.soil_extractions_N }}</div>
        <div v-if="showColumnByCrop">
          Extracción de P
        </div>
        <div v-if="showColumnByCrop">
          {{ data.soil_extractions_P }}
        </div>
        <div v-if="showColumnByCrop">
          Extracción de K
        </div>
        <div v-if="showColumnByCrop">
          {{ data.soil_extractions_K }}
        </div>
        <div v-if="showColumnByCrop">
          Extracción de Ca
        </div>
        <div v-if="showColumnByCrop">
          {{ data.soil_extractions_Ca }}
        </div>
        <div v-if="showColumnByCrop">
          Extracción de Mg
        </div>
        <div v-if="showColumnByCrop">
          {{ data.soil_extractions_Mg }}
        </div>
      </div>
      <div
        v-if="showColumnByCrop"
        class="table-2"
      >
        <div
          class="head"
          style="grid-column: 1 / 3;"
        >
          Recomendaciones estacionales fertilizante considerando la demanda de cultivo
          y los nutrientes disponibles en el suelo
        </div>

        <div>
          Abonado N (kg/ha)
        </div>
        <div>
          {{ data.soil_needs_N }}
        </div>

        <div>
          Abonado P (kg/ha)
        </div>
        <div>
          {{ data.seasonal_summary_fertilizer_P }}
        </div>

        <div>
          Abonado K (kg/ha)
        </div>
        <div>
          {{ data.seasonal_summary_fertilizer_K }}
        </div>

        <div>
          Abonado Ca (kg/ha)
        </div>
        <div>
          {{ data.seasonal_summary_fertilizer_Ca }}
        </div>

        <div>
          Abonado Mg (kg/ha)
        </div>
        <div>
          {{ data.seasonal_summary_fertilizer_Mg }}
        </div>
      </div>
      <div
        v-else
        class="table-2"
      >
        <div
          class="head"
          style="grid-column: 1 / 3;"
        >
          Recomendaciones estacionales fertilizante considerando la demanda de cultivo
          y los nutrientes disponibles en el suelo
        </div>

        <div>
          Abonado N (kg/ha)
        </div>
        <div>
          {{ data.soil_needs_N }}
        </div>
      </div>
      <div
        style="padding-right: 1rem; padding-left: 1rem;"
      >
        <span class="note">
          Nota: En el caso del N se hace un balance de N que considera,
          (a) el aporte de N desde el suelo,
          (b) la demanda del cultivo y
          (c) varios coeficientes de eficiencia del uso del N.
        </span>
      </div>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/manureResult/detailManure/"
            popover-close
            :title="$t('result.manure.seasonal_recommendation_nutrient_concentration')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-GreenHouse"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
    </f7-block-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_TABLES } from '../../../js/constants';

export default {
  name: 'SeasonalOverview',
  components: {
  },
  data() {
    return {
      data: {},
      NUMBER_OF_DECIMALS,
      TO_FIXED_DECIMALS_IN_TABLES,
    };
  },
  computed: {
    showColumnByCrop() {
      if (this.resultProject && this.resultProject.cultive) {
        switch (this.resultProject.cultive.crop_name) {
          case 'Sandía':
          case 'Berenjena':
          case 'Calabacín':
            return false;
          default:
            return true;
        }
      }
      return true;
    },
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  beforeMount() {
    this.$f7.preloader.show();
    const reducer = (accumulator, curr) => accumulator + curr;

    if (this.TO_FIXED_DECIMALS_IN_TABLES) {
      this.data.irrigation_volume = this.resultProject.result.irrigation_volume
        .reduce(reducer).toFixed(1);
      this.data.minerilized_N_soil = this.resultProject.result.minerilized_N_soil
        .reduce(reducer).toFixed(1);
      this.data.minerilized_N = this.resultProject.result.minerilized_N
        .reduce(reducer).toFixed(1);
      this.data.soil_extractions_N = this.resultProject.result.soil_extractions_N
        .reduce(reducer).toFixed(1);
      this.data.soil_extractions_Ca = this.resultProject.result.soil_extractions_Ca
        .reduce(reducer).toFixed(1);
      this.data.soil_extractions_K = this.resultProject.result.soil_extractions_K
        .reduce(reducer).toFixed(1);
      this.data.soil_extractions_Mg = this.resultProject.result.soil_extractions_Mg
        .reduce(reducer).toFixed(1);
      this.data.soil_extractions_P = this.resultProject.result.soil_extractions_P
        .reduce(reducer).toFixed(1);
      this.data.soil_needs_N = this.resultProject.result.soil_needs_N
        .reduce(reducer).toFixed(1);
      this.data.soil_needs_Ca = this.resultProject.result.soil_needs_Ca
        .reduce(reducer).toFixed(1);
      this.data.soil_needs_K = this.resultProject.result.soil_needs_K
        .reduce(reducer).toFixed(1);
      this.data.soil_needs_Mg = this.resultProject.result.soil_needs_Mg
        .reduce(reducer).toFixed(1);
      this.data.soil_needs_P = this.resultProject.result.soil_needs_P
        .reduce(reducer).toFixed(1);
      this.data.seasonal_summary_fertilizer_Ca = this.resultProject.result
        .seasonal_summary_fertilizer_Ca[0].toFixed(1);
      this.data.seasonal_summary_fertilizer_K = this.resultProject.result
        .seasonal_summary_fertilizer_K[0].toFixed(1);
      this.data.seasonal_summary_fertilizer_Mg = this.resultProject.result
        .seasonal_summary_fertilizer_Mg[0].toFixed(1);
      this.data.seasonal_summary_fertilizer_P = this.resultProject.result
        .seasonal_summary_fertilizer_P[0].toFixed(1);
    } else {
      this.data.irrigation_volume = this.resultProject.result.irrigation_volume
        .reduce(reducer);
      this.data.minerilized_N_soil = this.resultProject.result.minerilized_N_soil
        .reduce(reducer);
      this.data.minerilized_N = this.resultProject.result.minerilized_N
        .reduce(reducer);
      this.data.soil_extractions_N = this.resultProject.result.soil_extractions_N
        .reduce(reducer);
      this.data.soil_extractions_Ca = this.resultProject.result.soil_extractions_Ca
        .reduce(reducer);
      this.data.soil_extractions_K = this.resultProject.result.soil_extractions_K
        .reduce(reducer);
      this.data.soil_extractions_Mg = this.resultProject.result.soil_extractions_Mg
        .reduce(reducer);
      this.data.soil_extractions_P = this.resultProject.result.soil_extractions_P
        .reduce(reducer);
      this.data.soil_needs_N = this.resultProject.result.soil_needs_N
        .reduce(reducer);
      this.data.soil_needs_Ca = this.resultProject.result.soil_needs_Ca
        .reduce(reducer);
      this.data.soil_needs_K = this.resultProject.result.soil_needs_K
        .reduce(reducer);
      this.data.soil_needs_Mg = this.resultProject.result.soil_needs_Mg
        .reduce(reducer);
      this.data.soil_needs_P = this.resultProject.result.soil_needs_P
        .reduce(reducer);
      this.data.seasonal_summary_fertilizer_Ca = this.resultProject.result
        .seasonal_summary_fertilizer_Ca[0];
      this.data.seasonal_summary_fertilizer_K = this.resultProject.result
        .seasonal_summary_fertilizer_K[0];
      this.data.seasonal_summary_fertilizer_Mg = this.resultProject.result
        .seasonal_summary_fertilizer_Mg[0];
      this.data.seasonal_summary_fertilizer_P = this.resultProject.result
        .seasonal_summary_fertilizer_P[0];
    }
    this.$f7.preloader.hide();
  },
  methods: {
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/', { reloadCurrent: true });
    },
  },
};
</script>
<style
    lang="scss"
    scoped
>
@import "../../../css/mixins";
.boton-greenHouse {
  background: #FF7F26;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.boton-openAir {
  background: #51A411;
  height: 30px;
  width: 100px;
  margin-top: 60px;
  text-align: center;
}
.content-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
}

.table-1 {
  display: grid;
  width:auto;
  margin: 0 1rem 1rem;
  grid-template-columns: 1fr 1fr 1fr;
  .head {
    font-weight: 700;
    text-align: center;
    background: #F4F5F7 !important;
    font-family: 'Roboto';
    line-height: 16px;
    color: #616B7C;
    padding: 0.5rem;
    text-align: center;
  }
}
.table-1 > div {
  padding: 6px;
  border:1px solid #C0C9CE;
  background: #FFFFFF;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-2 {
  display: grid;
  width: auto;
  margin: 1rem;
  grid-template-columns: 1fr 1fr;
  .head {
    font-weight: 700;
    text-align: center;
    background: #F4F5F7 !important;
    font-family: 'Roboto';
    line-height: 16px;
    color: #616B7C;
    padding: 0.5rem;
  }
}
.table-2 > div {
  padding: 6px;
  border:1px solid #C0C9CE;
  background: #FFFFFF;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.note {
  font-family: 'Roboto';
  font-style: normal;
  text-align: center;
  line-height: normal;
  color: steelblue;
  font-size: small;
  @include md {
    font-size: large;
    line-height: 28px;
  }
}
</style>
